/* eslint-disable max-lines */
import { BuriedEventTrigger } from './index';
// NOTE： 全局存储埋点事件Map的地方,reception的侧边栏埋点在3.4弃用
// 文档地址：https://docs.popo.netease.com/lingxi/68844160c1914ed3946518ca95201c2e?tab=1
// element_name 对应key, page_name 设置为自定义字段即可
export const BuriedEventPortal = {
    /*
     官网
    */
    /* ___底部营销入口____*/
    o_bottom_market: {
        key: 'o_bottom_market',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    /* ___官网首页页面中的模块____*/
    o_homepage_top_btn_consult: {
        key: 'o_homepage_top_btn_consult',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_scene_btn_consult: {
        key: 'o_homepage_scene_btn_consult',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_virtual_avatar_btn_consult: {
        key: 'o_homepage_virtual_avatar_btn_consult',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_knowus_btn_consult: {
        key: 'o_knowus_btn_consult',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    /* ___咨询区域____*/
    o_side_tab_btn_consult: {
        key: 'o_side_tab_btn_consult',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    /* ___提交咨询按钮，这里要通过c3传递途径element_name____*/
    o_contact_btn_submit_consult: {
        key: 'o_contact_btn_submit_consult',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_marketing: {
        key: 'o_homepage_consult_marketing',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_tour: {
        key: 'o_homepage_consult_tour',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_private: {
        key: 'o_homepage_consult_private',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_space: {
        key: 'o_homepage_consult_space',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_exhibition: {
        key: 'o_homepage_consult_exhibition',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_other: {
        key: 'o_homepage_consult_other',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    o_homepage_consult_submit: {
        key: 'o_homepage_consult_submit',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.CLK,
    },
    // 咨询模块曝光
    o_homepage_consult_card_exposure: {
        key: 'o_homepage_consult_card_exposure',
        page_name: 'o_p_home_page',
        event: BuriedEventTrigger.EXP,
    },
    o_core_technology_consult_100: {
        key: 'o_core_technology_consult_100',
        page_name: 'o_p_core_technology_page',
        event: BuriedEventTrigger.CLK,
    },
    o_core_technology_consult_200: {
        key: 'o_core_technology_consult_200',
        page_name: 'o_p_core_technology_page',
        event: BuriedEventTrigger.CLK,
    },
    o_core_technology_consult_500: {
        key: 'o_core_technology_consult_500',
        page_name: 'o_p_core_technology_page',
        event: BuriedEventTrigger.CLK,
    },
    o_core_technology_consult_more: {
        key: 'o_core_technology_consult_more',
        page_name: 'o_p_core_technology_page',
        event: BuriedEventTrigger.CLK,
    },
    o_core_technology_consult_submit: {
        key: 'o_core_technology_consult_submit',
        page_name: 'o_p_core_technology_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industrialreports_consult_submit: {
        key: 'o_industrialreports_consult_submit',
        page_name: 'o_p_industrialreports_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industrialreports_consult_card_exposure: {
        key: 'o_industrialreports_consult_card_exposure',
        page_name: 'o_p_industrialreports_page',
        event: BuriedEventTrigger.EXP,
    },
    // 留咨卡片曝光
    o_core_technology_consult_card_exposure: {
        key: 'o_core_technology_consult_card_exposure',
        page_name: 'o_p_core_technology_page',
        event: BuriedEventTrigger.EXP,
    },
    o_news_consult_100: {
        key: 'o_news_consult_100',
        page_name: 'o_p_news_page',
        event: BuriedEventTrigger.CLK,
    },
    o_news_consult_200: {
        key: 'o_news_consult_200',
        page_name: 'o_p_news_page',
        event: BuriedEventTrigger.CLK,
    },
    o_news_consult_500: {
        key: 'o_news_consult_500',
        page_name: 'o_p_news_page',
        event: BuriedEventTrigger.CLK,
    },
    o_news_consult_more: {
        key: 'o_news_consult_more',
        page_name: 'o_p_news_page',
        event: BuriedEventTrigger.CLK,
    },
    o_news_consult_submit: {
        key: 'o_news_consult_submit',
        page_name: 'o_p_news_page',
        event: BuriedEventTrigger.CLK,
    },
    // 新闻报道的留咨卡片
    o_news_consult_card_exposure: {
        key: 'o_news_consult_card_exposure',
        page_name: 'o_p_news_page',
        event: BuriedEventTrigger.EXP,
    },
    o_daka_consult_marketing: {
        key: 'o_daka_consult_marketing',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    o_daka_consult_tour: {
        key: 'o_daka_consult_tour',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    o_daka_consult_private: {
        key: 'o_daka_consult_private',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    o_daka_consult_space: {
        key: 'o_daka_consult_space',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    o_daka_consult_exhibition: {
        key: 'o_daka_consult_exhibition',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    o_daka_consult_other: {
        key: 'o_daka_consult_other',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    o_daka_consult_submit: {
        key: 'o_daka_consult_submit',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.CLK,
    },
    // 大咖曝光
    o_daka_consult_card_exposure: {
        key: 'o_daka_consult_card_exposure',
        page_name: 'o_p_daka_page',
        event: BuriedEventTrigger.EXP,
    },
    // 学术会议的留咨
    o_learning_consult_marketing: {
        key: 'o_learning_consult_marketing',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.CLK,
    },
    o_learning_consult_tour: {
        key: 'o_learning_consult_tour',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.CLK,
    },
    o_learning_consult_private: {
        key: 'o_learning_consult_private',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.CLK,
    },
    o_learning_consult_space: {
        key: 'o_learning_consult_space',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.CLK,
    },
    o_learning_consult_exhibition: {
        key: 'o_learning_consult_exhibition',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.CLK,
    },
    o_learning_consult_other: {
        key: 'o_learning_consult_other',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.CLK,
    },
    // 学术会议曝光
    o_learning_consult_card_exposure: {
        key: 'o_learning_consult_card_exposure',
        page_name: 'o_p_learning_page',
        event: BuriedEventTrigger.EXP,
    },
    // 行业峰会
    o_industry_summit_consult_marketing: {
        key: 'o_industry_summit_consult_marketing',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industry_summit_consult_tour: {
        key: 'o_industry_summit_consult_tour',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industry_summit_consult_private: {
        key: 'o_industry_summit_consult_private',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industry_summit_consult_space: {
        key: 'o_industry_summit_consult_space',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industry_summit_consult_exhibition: {
        key: 'o_industry_summit_consult_exhibition',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.CLK,
    },
    o_industry_summit_consult_other: {
        key: 'o_industry_summit_consult_other',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.CLK,
    },
    // 行业峰会曝光
    o_industry_summit_consult_card_exposure: {
        key: 'o_industry_summit_consult_card_exposure',
        page_name: 'o_p_industry_summit_page',
        event: BuriedEventTrigger.EXP,
    },
    // 车展解决方案
    o_carshow_consult_marketing: {
        key: 'o_carshow_consult_marketing',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_carshow_consult_tour: {
        key: 'o_carshow_consult_tour',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_carshow_consult_private: {
        key: 'o_carshow_consult_private',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_carshow_consult_space: {
        key: 'o_carshow_consult_space',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_carshow_consult_exhibition: {
        key: 'o_carshow_consult_exhibition',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_carshow_consult_other: {
        key: 'o_carshow_consult_other',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.CLK,
    },
    // 车展解决方案曝光
    o_carshow_consult_card_exposure: {
        key: 'o_carshow_consult_card_exposure',
        page_name: 'o_p_carshow_page',
        event: BuriedEventTrigger.EXP,
    },
    // 艺术解决方案
    o_artshow_consult_marketing: {
        key: 'o_artshow_consult_marketing',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_artshow_consult_tour: {
        key: 'o_artshow_consult_tour',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_artshow_consult_private: {
        key: 'o_artshow_consult_private',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_artshow_consult_space: {
        key: 'o_artshow_consult_space',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_artshow_consult_exhibition: {
        key: 'o_artshow_consult_exhibition',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.CLK,
    },
    o_artshow_consult_other: {
        key: 'o_artshow_consult_other',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.CLK,
    },
    // 艺术展曝光
    o_artshow_consult_card_exposure: {
        key: 'o_artshow_consult_card_exposure',
        page_name: 'o_p_artshow_page',
        event: BuriedEventTrigger.EXP,
    },
};
